"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* What an editor's Preview fills a template with: the chat's patient, team
 * and org when there is one (Save as template), otherwise a sample patient,
 * my first team (or the org's first) and my org (Settings). */
var _react = require('react');



var _myRelations = require('shared/selectors/myRelations');
var _user = require('shared/selectors/user');
var _templateResolver = require('shared/services/templateResolver');
var _typed = require('shared/hooks/typed');

 const useTemplatePreviewContext = (
  orgKey,
  orgName,
  teams,
  previewContext,
) => {
  const senderName = _typed.useAppSelector.call(void 0, state => _optionalChain([_user.selectCurrentUserV2.call(void 0, state), 'optionalAccess', _ => _.Name]))
  const myTeamName = _typed.useAppSelector.call(void 0, state => _optionalChain([_myRelations.selectMyTeamGroupsList.call(void 0, state), 'access', _2 => _2.find, 'call', _3 => _3(g => g.orgKey === orgKey), 'optionalAccess', _4 => _4.teamsList, 'access', _5 => _5[0], 'optionalAccess', _6 => _6.Name]))
  const context = _react.useMemo.call(void 0, 
    () => _nullishCoalesce(previewContext, () => ( _templateResolver.sampleTemplateContext.call(void 0, { senderName, orgName, teamName: _nullishCoalesce(_nullishCoalesce(myTeamName, () => ( _optionalChain([teams, 'access', _7 => _7[0], 'optionalAccess', _8 => _8.Name]))), () => ( null)) }))),
    [previewContext, senderName, orgName, myTeamName, teams],
  )
  return { context, sample: !previewContext }
}; exports.useTemplatePreviewContext = useTemplatePreviewContext
